import { render, staticRenderFns } from "./share-card.vue?vue&type=template&id=18d3d62c&scoped=true&"
import script from "./share-card.vue?vue&type=script&lang=js&"
export * from "./share-card.vue?vue&type=script&lang=js&"
import style0 from "./share-card.vue?vue&type=style&index=0&id=18d3d62c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d3d62c",
  null
  
)

export default component.exports